import { createActionTypes } from '../../../../util/createActionsHelpers';

export const GET_USER = createActionTypes('GET_USER');
